import {Box, Grid} from 'platform/foundation';

import {ReactNode} from 'react';

import {SOURCING_CARD_GEOMETRY} from '../constants/SOURCING_CARD_GEOMETRY';

interface CardStatsGridProps {
  enhancedSurfaces: boolean;
  children: ReactNode;
}

/**
 * Stats of a sourcing card laid out in as many equal columns as fit the card, so the cells wrap
 * instead of overlapping in a narrow card.
 */
export function CardStatsGrid(props: CardStatsGridProps) {
  return (
    <Box
      paddingTop={props.enhancedSurfaces ? 3 : undefined}
      borderTop={props.enhancedSurfaces ? '1px solid' : undefined}
      borderColor="general.separator"
    >
      <Grid minColumnWidth={SOURCING_CARD_GEOMETRY.statMinWidth} spacing={2}>
        {props.children}
      </Grid>
    </Box>
  );
}
